import React from "react";
import Grid from "@mui/material/Grid";
import styled from "styled-components";
import SlidingPane from "../../../common/slidingPane";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import "react-datepicker/dist/react-datepicker.css";

type props = {
  open?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  jobState: any;
  setJobState: any;
};
const Filter = ({ open, setOpen, jobState, setJobState }: props) => {
  const [value, setValue] = React.useState("female");
  const [dateRange, setDateRange] = React.useState([null, null]);
  const [startDate, endDate] = dateRange;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setJobState(event.target.value);
  };

  return (
    <Bigsection>
      {" "}
      <SlidingPane open={open} setOpen={setOpen}>
        <Grid container columns={12}>
          <Grid item xs={12} className="line">
            <h3>Reports jobs filter</h3>
          </Grid>
          <Grid item xs={12} my={3}>
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">Filter</FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="pending"
                name="radio-buttons-group"
                value={jobState}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="all"
                  control={<Radio size="small" />}
                  label="All"
                />
                <FormControlLabel
                  value="pending"
                  control={<Radio size="small" />}
                  label="Pending"
                />
                <FormControlLabel
                  value="new"
                  control={<Radio size="small" />}
                  label="New"
                />
                <FormControlLabel
                  value="completed"
                  control={<Radio size="small" />}
                  label="Completed"
                />
                <FormControlLabel
                  value="in_progress"
                  control={<Radio size="small" />}
                  label="In Progress"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            {/* <DatePicker
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              // onChange={(update) => {
              //   setDateRange(update);
              // }}
              isClearable={true}
            /> */}
          </Grid>
        </Grid>
      </SlidingPane>
    </Bigsection>
  );
};
const Bigsection = styled.div`
  .line {
    &:after {
      position: absolute;
      content: "";
      background-color: #e9ebf8;
      width: 100%;
      height: 3px;
      left: 0;
      top: 3rem;
    }
  }
  background: #ffffff !important;
  .css-vqmohf-MuiButtonBase-root-MuiRadio-root.Mui-checked {
    color: #00818a;
  }
  .css-u4tvz2-MuiFormLabel-root.Mui-focused {
    color: #101828;
  }
`;
export default Filter;
